import { useEffect } from 'react'
import { useInterval } from '~shared/hooks/useInterval'
import {
  parseBuildVersion,
  getCurrentBuildVersion,
  createThrottledExceptionLogger,
} from '~shared/util/versionUtil'
import GlobalStore from '../Stores/GlobalStore'

const BASE_ROUTE = '/kdsapp'
const POLL_INTERVAL_MS = 10000
const CONFIG_REFRESH_INTERVAL_MS = 5 * 60000
const logVersionError = createThrottledExceptionLogger()

const getPollRoute = () => {
  const path = window.location.pathname
  return path === BASE_ROUTE || path.startsWith(`${BASE_ROUTE}/`) ? BASE_ROUTE : '/'
}

export const UpdateMonitor = () => {
  useEffect(() => {
    const pollRoute = getPollRoute()

    const pollForNewVersion = async () => {
      try {
        const response = await fetch(pollRoute)
        if (response.ok) {
          const html = await response.text()
          const remoteBuildVersion = parseBuildVersion(html)
          const localBuildVersion = getCurrentBuildVersion()

          if (remoteBuildVersion && localBuildVersion && remoteBuildVersion !== localBuildVersion) {
            window.location.reload()
          }
        }
      } catch (error) {
        logVersionError(error)
      }
    }

    const intervalId = setInterval(pollForNewVersion, POLL_INTERVAL_MS)
    pollForNewVersion()

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  useInterval(() => {
    void GlobalStore.refreshConfig()
  }, CONFIG_REFRESH_INTERVAL_MS)

  return null
}
